'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const [room, setRoom] = useState('');
  const router = useRouter();

  const goJoin = () => {
    const r = room.trim();
    if (!r) return;
    router.push(`/rooms/${encodeURIComponent(r)}`);
  };

  const goStudio = () => {
    const r = room.trim();
    if (!r) return;
    router.push(`/studio?room=${encodeURIComponent(r)}`);
  };

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#050505', color: '#fff' }}>
      <div style={{ width: 420, maxWidth: '92vw', padding: 24, border: '1px solid #222', borderRadius: 16, background: '#0b0b0b' }}>
        <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>TLCAST</div><input
          value={room}
          onChange={(e) => setRoom(e.target.value)}
          placeholder="ROOM NAME"
          style={{
            width: '100%',
            marginTop: 6,
            marginBottom: 14,
            padding: '10px 12px',
            borderRadius: 10,
            border: '1px solid #333',
            background: '#111',
            color: '#fff',
            outline: 'none',
          }}
        />

        <div style={{ display: 'grid', gap: 10 }}>
          <button onClick={goJoin} style={btnStyle}>Join</button></div>
      </div>
    </main>
  );
}

const btnStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 10,
  border: '1px solid #333',
  background: '#222',
  color: '#fff',
  cursor: 'pointer',
};
